
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/[...slug]",
      function () {
        return require("private-next-pages/community/[...slug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/[...slug]"])
      });
    }
  